import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { OldTextarea } from 'src/domains/layouts/shared/formComponents/textarea/OldTextarea';
import { ErrorMessageBar } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { LanguagesSelect } from '../LanguageSelect/LanguageSelect';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { FormComponent, FormWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';

export const PagesForm = observer('PagesForm', () => {
    const { pagesState, languageState } = useAppStateContext();
    const {
        isLoading,
        errorMessage,
        isFormValid,
        isEditMode,
        title,
        titleStatus,
        titleModel,
        page_description,
        descriptionStatus,
        descriptionModel,
        seo_title,
        seoTitleStatus,
        seoTitleModel,
        slug,
        slugModel,
        slugStatus,
        content,
        contentStatus,
        contentModel,
        keywords,
        keywordsStatus,
        keywordsModel,
        language,
        handleCancel,
        handleSubmit,
        setDefaultState,
        setLanguage
    } = pagesState;

    return (
        <FormWrapper>
            <FormHeader isEditMode={isEditMode} defaultLabel='Create new page' editModeLabel='Edit page' resetForm={setDefaultState}/>
            <FormComponent onSubmit={(e): void => e.preventDefault()}>
                <Loader isActive={isLoading}/>

                {!!errorMessage && <ErrorMessageBar key='error-message'>{errorMessage}</ErrorMessageBar>}


                <LanguagesSelect setAction={setLanguage} value={language} selectOptions={languageState.languages}/>

                <OldInput
                    label='Slug*'
                    status={slugStatus}
                    formInputState={slug}
                    model={slugModel}
                    dataTest='add-page-slug'
                />

                <OldInput
                    label='Page Title*'
                    status={titleStatus}
                    formInputState={title}
                    model={titleModel}
                    dataTest='add-page-title'
                />

                <OldTextarea
                    label='Content'
                    formState={content}
                    model={contentModel}
                    status={contentStatus}
                    ckeditor
                    dataTest='add-page-content'
                />

                <OldInput
                    label='Description'
                    status={descriptionStatus}
                    formInputState={page_description}
                    model={descriptionModel}
                    dataTest='add-page-description'
                />

                <OldInput
                    label='Keywords'
                    status={keywordsStatus}
                    formInputState={keywords}
                    model={keywordsModel}
                    dataTest='add-page-keywords'
                />
                        
                <OldInput
                    label='SEO title'
                    status={seoTitleStatus}
                    formInputState={seo_title}
                    model={seoTitleModel}
                    dataTest='add-page-seo-title'
                />

                <FormButtons
                    onCreate={handleSubmit}
                    onUpdate={handleSubmit}
                    onCancel={handleCancel}
                    isEditMode={isEditMode}
                    isCreateDisabled={!isFormValid}
                    isUpdateDisabled={!isFormValid}
                    dataTestCreate='create-page-button'
                    dataTestUpdate='create-page-button'
                />
            </FormComponent>
        </FormWrapper>
    );
});
